require.register("collection/controllers/indexCtrl", function(exports, require, module){
  $0
  
});

